import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage04 from "../../../../../../assets/images/ActiveLearning/hint/img_04.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          前回のLessonで考えた「問い」の原型を具体的にして、もっと自分が取り組みたくなる内容にしよう。
          <br />
          ヒントを参考に様々な視点から「問い」の具体的な案を考えて、思いつく限り入力してみよう。
        </p>
      </div>
      {question && (
        <div className={clsx(styles.question, styles.secondary)}>
          <TextArea />
        </div>
      )}
      <img src={hintImage04} alt="「問い」を具体的にするためのヒント" />
    </div>
  );
};
export default Issue1Material;
